import Clear from './../layouts/Clear.vue';

export default {
  path: '/fees',
  component: Clear,
  children: [
    {
      path: '',
      name: 'fees.index',
      component: () => import('@/views/fees/index.vue'),
    },
  ],
};
